import {useThemeColors} from '@nfq/colors';

/**
 * A custom hook that provides theme-based color values for the `Quote` component.
 * This hook retrieves the application's theme colors via `useThemeColors` and exposes them
 * for use in styling the quote text, author name, and other visual elements. It ensures that
 * the `Quote` component adapts correctly to the current theme context.
 *
 * @returns An object containing `colors`, which holds theme-defined color values.
 *
 * @example
 * ```tsx
 * const { colors } = useQuote();
 *
 * return <span style={{ color: colors.textPrimaryInverted }}>Quote text</span>;
 * ```
 */
export const useQuote = () => {
    const colors = useThemeColors();

    return {colors};
};